<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="row otherWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/project/p-icon1.png" />
            <span>图片新闻</span>
            <router-link :to="{ name: 'PicPage', query: { name: '图片新闻' }}" class="more right">更多</router-link>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 page-swiper">
            <div class="swiper-container pro-swiper" v-if="slideList.length">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(sitem, sidx) in slideList" :key="sidx" @click="newsDetail('图片新闻', sitem.id)">
                  <img v-if="sitem.imgurl" :src="globalVar.imgUrl+sitem.imgurl" alt />
                  <img v-else src="../../static/images/news/slide.png" alt />
                  <div class="newss-title">
                    <h4>{{sitem.title}}</h4>
                    <p>
                      <v-clamp autoresize :max-lines="1">{{sitem.content.trim()}}</v-clamp>
                    </p>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination newsPagination"></div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/project/p-icon2.png" />
            <span>公告板</span>
            <router-link :to="{ name: 'BoardPage', query: { name: '公告板' }}" class="more right">更多</router-link>
          </div>
          <div class="page-wrap">
            <div class="page-other" v-for="(bitem, bidx) in boardList" :key="bidx" @click="newsDetail('公告板', bitem.id)">
              <p>
                <v-clamp autoresize :max-lines="1">{{bitem.title}}</v-clamp>
              </p>
              <span>{{bitem.createtime}}</span>
            </div>
          </div>
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/project/p-icon3.png" />
            <span>对接服务指南</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in projectList" :key="idx" @click="jump(item)">
              <v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row four-enterWrap">
      <div class="container page-three-enter">
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter">
          <router-link :to="{name: 'pdfProPage', query: {name: '项目对接会安排'}}">
            <img src="../../static/images/project/enter1.png" alt="项目对接会安排" />
          </router-link>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter">
          <router-link to="/topic">
            <img src="../../static/images/project/enter4.png" alt="投资万里行" />
          </router-link>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter">
          <!-- <router-link :to="{name: 'proSearchPage', query: {name: '投资商查询'}}">
            <img src="../../static/images/project/enter2.png" />
          </router-link> -->
          <a href="https://manage.touzicloud.com/" target="_blank" class="pclink"><img src="../../static/images/project/enter2.png" alt="项目投资商搜索中心" /></a>
        </div>
      </div>
    </div>
    <div class="row proWrap" style="display:none;">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/project/p-icon4.png" />
            <span>境内项目</span>
            <router-link class="more right" :to="{name: 'proSearchPage', query: {name: '项目查询', projectType: 0}}">更多</router-link>
          </div>
          <div class="row page-pro">
            <div class="col-xs-12 col-sm-3 col-md-3 page-pro-list" v-for="(ditem, didx) in domestic" :key="didx">
              <a class="page-pro-main" :href="globalVar.pdfUrl+'/#/ProjectProDet?name=项目查询&id='+ditem.projectID" target="_blank">
                <h3>
                  <v-clamp autoresize :max-lines="1">{{ditem.projectName ? ditem.projectName : ditem.projectEName}}</v-clamp>
                </h3>
                <p>
                  <v-clamp autoresize :max-lines="1">{{ditem.projectTrade ? ditem.projectTrade : '-'}}</v-clamp>
                </p>
                <div class="area">{{ditem.projectArea ? ditem.projectArea : '-'}}</div>
                <div class="date">{{ditem.createDateTime}}</div>
                <span class="readMore">查看更多>></span>
              </a>
            </div>
          </div>
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/project/p-icon5.png" />
            <span>境外项目</span>
            <router-link class="more right" :to="{name: 'proSearchPage', query: {name: '项目查询', projectType: 1}}">更多</router-link>
          </div>
          <div class="row page-pro">
            <div class="col-xs-12 col-sm-3 col-md-3 page-pro-list" v-for="(oitem, oidx) in overseas" :key="oidx">
              <a class="page-pro-main" :href="globalVar.pdfUrl+'/#/ProjectProDet?name=项目查询&id='+oitem.projectID" target="_blank">
                <h3>
                  <v-clamp autoresize :max-lines="1">{{oitem.projectName ? oitem.projectName : oitem.projectEName}}</v-clamp>
                </h3>
                <p>
                  <v-clamp autoresize :max-lines="1">{{oitem.projectTrade ? oitem.projectTrade : '-'}}</v-clamp>
                </p>
                <div class="area">{{oitem.projectArea ? oitem.projectArea : '-'}}</div>
                <div class="date">{{oitem.createDateTime}}</div>
                <span class="readMore">查看更多>></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subMenuBar from "@/components/subMenuBar/subMenuBar";
import VClamp from "vue-clamp";
export default {
  components: {
    subMenuBar,
    VClamp
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.project,
      tabList: ["9月7号", "9月8号", "9月9号", "9月10号", "9月11号"],
      tabIndex: 0,
      projectList: [
        {
          title: "项目对接会简介",
          pathName: "infoPPage",
          name: "项目对接会简介"
        },
        {
          title: "项目对接会邀请函",
          pathName: "pdfProPage",
          name: "项目对接会邀请函"
        },
        {
          title: "走出去邀请函",
          pathName: "pdfProPage",
          name: "走出去邀请函"
        },
        {
          title: "项目填报",
          pathName: "boothProPage",
          name: "网上报名参展"
        },
        {
          title: "投资商报名",
          pathName: "",
          name: ""
        },
        {
          title: "联络组委会项目组",
          pathName: "contactProPage",
          name: "联络组委会项目组"
        },
        {
          title: "相关投资机构网站",
          pathName: "websiteProPage",
          name: "相关投资机构网站"
        }
      ],
      domestic: Array,
      overseas: Array,
      slideList: Array,
      boardList: Array
    };
  },
  async created () {
    await this.init();
  },
  async activated () {
    await this.findimgnews();
  },
  methods: {
    subpagemenu (item) {
      if (item.subName == "投资商报名") {
        window.location.href = this.globalVar.SelfServicelogin;
      } else {
        this.$router.push({
          name: item.pathName,
          query: {
            name: item.subName
          }
        });
      }
    },
    jump (item) {
      if (item.title == "投资商报名") {
        window.location.href = this.globalVar.SelfServicelogin;
      } else if (item.title == "项目填报") {
        window.location.href = this.globalVar.ProjectFilling
      } else {
        this.$router.push({
          name: item.pathName,
          query: {
            name: item.name
          }
        });
      }
    },
    async init () {
      this.domestic = await this.project(0); //境内项目列表
      this.overseas = await this.project(1); //境外项目列表
      // await this.findimgnews();

      this.boardList = await this.getData();
    },
    project (type) {
      let params = {
        language: this.globalVar.lang,
        count: 8,
        type: type
      };
      return this.$store.dispatch("projectlist", params);
    },
    proDetail (id) {
      this.$router.push({
        name: "ProDetProject",
        query: {
          name: "项目详情",
          id: id
        }
      });
    },
    getData (count, type) {
      let params = {
        count: 6,
        type: 8, //8：项目对接公告板
        language: this.globalVar.lang
      };
      return this.$store.dispatch("find", params);
    },
    async findimgnews () {
      let params = {
        count: 5,
        position: 5, //5：项目对接图片新闻
        language: this.globalVar.lang
      };
      this.slideList = [];
      this.slideList = await this.$store.dispatch("find", params);
      this.swiperInte();
    },
    swiperInte () {
      this.$nextTick(function () {
        var proSwiper = new Swiper(".pro-swiper", {
          // direction: "vertical", // 垂直切换选项
          loop: true, // 循环模式选项
          // 如果需要分页器
          pagination: {
            el: ".swiper-pagination"
          },
          // 如果需要前进后退按钮
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          // 如果需要滚动条
          scrollbar: {
            el: ".swiper-scrollbar"
          }
        });
        if (proSwiper.slides.length <= 3) {
          proSwiper.lockSwipes();
        }
      });
    },
    newsDetail (type, id) {
      this.$router.push({
        name: "NewsDetProject",
        query: {
          name: type,
          id: id
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
@import "../../static/function.less";
.otherWrap {
  margin-bottom: 4%;
  .page-header-news {
    margin-top: 3%;
  }
  .page-swiper {
    padding-top: 15px;
    .swiper-slide {
      text-align: center;
      .newss-title {
        position: absolute;
        bottom: 0px;
        background: rgba(0, 0, 0, 0.7);
        left: 0;
        right: 0;
        padding: 2% 3%;
        color: #fff;
        text-align: left;
        h4 {
          line-height: 24px;
          font-size: @font16;
        }
        p {
          font-size: @font14;
          margin: 1% 0px 3% 0px;
        }
      }
    }
  }
  .newsPagination {
    bottom: 0px;
  }
  .page-wrap {
    padding-top: 2%;
    .page-other {
      margin-top: 1%;
      cursor: pointer;
      &:hover {
        p {
          .hoverTxtColor();
        }
      }
      &:before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 3px;
        background-color: #f00;
        vertical-align: top;
        margin-top: 8px;
        margin-right: 6px;
        border-radius: 50%;
      }
      p {
        display: inline-block;
        width: 73%;
        font-size: @font14;
        color: #303133;
      }
      span {
        color: @color767676;
        float: right;
        margin-top: 2px;
      }
    }
  }
  .page-list {
    margin-top: 5%;
    padding: 0 3%;
    cursor: pointer;
    p {
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover {
        .hoverTxtColor();
      }
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
  }

  .answer {
    margin-top: 3%;
    padding-left: 20px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      background: url("../../static/images/forum/bg.png") no-repeat center;
      width: 16px;
      height: 16px;
      display: inline-block;
      background-size: cover;
    }
    h3 {
      font-size: @font16;
      color: #333;
      font-weight: bold;
    }
    p {
      font-size: @font14;
      margin: 10px 0px;
      line-height: 24px;
      a {
        color: #2d9bf0;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.four-enterWrap {
  width: 100%;
  font-size: 20px;
  color: #303133;
  font-weight: bold;
  padding: 3%;
  background: url("../../static/images/index/adBg.png") no-repeat center;
  background-size: cover;
  .page-three-enter {
    width: 800px;
  }
  .page-four-enter {
    padding: 1%;
    cursor: pointer;
    text-align: center;
    a {
      display: inline-block;
    }
    &:hover {
      img {
        .shadow(4px);
      }
    }
  }
}
.proWrap {
  margin-top: 2%;
  .page-pro {
    margin: 15px 0px;
    .page-pro-list {
      margin: 15px 0px;
      .page-pro-main {
        display: block;
        text-align: center;
        padding: 15px;
        border: 1px solid #f5f5f5;
        background-color: #f5f9fe;
        font-size: @font14;
        cursor: pointer;
        h3 {
          font-size: @font18;
          font-weight: 400;
          margin-bottom: 3%;
        }
        p {
          color: #333;
          margin-bottom: 3%;
        }
        .area {
          color: #333;
          margin-bottom: 3%;
        }
        .date {
          color: @color767676;
          margin-bottom: 3%;
        }
        .readMore {
          color: @color2d9bf0;
        }
        &:hover {
          .shadow(0px);
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 767px) {
  .slideMenu {
    display: block;
  }
  .four-enterWrap .page-three-enter {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Project.vue